import styled from 'styled-components'
import { v1 as color, contentLevels } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

export const Wrapper = styled.div`
  position: relative;

  .Select-menu-outer {
    // dropdown type list components are given a z-index that is
    // just below the next major content level because in most cases
    // dropdown list options should be above pretty much everything
    // else that could block them, except for everything in the next
    // content level up. This is why we do a -1 here.
    z-index: ${contentLevels.navigation - 1};

    // pass dropDown false to make it a dropUp. This is a workaround
    // until we eventually upgrade react-select to a newer version
    ${p =>
      !p.dropDown &&
      `
      top: auto;
      bottom: 100%;
    `}
  }
`

export const Icon = styled(BaseIcon)`
  font-size: 1.5rem;
  vertical-align: middle;
  position: absolute;
  top: 50%;
  left: 0.9375rem;
  margin-top: -0.75rem;
  color: ${color.SILVER};
  z-index: 10;
`

export const Label = styled.span`
  transition: all 0.2s;
  position: absolute;
  top: 2px;
  left: 2px;
  height: 3.125rem;
  line-height: 3.125rem;
  font-size: 22px;
  color: #0e60c9;
  background-color: white;
  left: 15px;
  padding: 0 5px;
  opacity: 0;

  &:focus {
    padding-left: 19px;
    border: 2px solid #0e60c9;
  }

  ${p =>
    p.visited &&
    `
    top: -10px;
    height: 22px;
    line-height: 22px;
    left: 10px;
    padding: 0 5px;
    font-size: 16px;
    opacity: 1;
    z-index: 9;
    color: ${p => p.theme.labelColor};
  `};
`
